import { render } from "./Menu_fitbar.vue?vue&type=template&id=4618325b&scoped=true"
import script from "./Menu_fitbar.vue?vue&type=script&lang=js"
export * from "./Menu_fitbar.vue?vue&type=script&lang=js"

import "./Menu_fitbar.vue?vue&type=style&index=0&id=4618325b&scoped=true&lang=css"

import exportComponent from "/Users/bencorp/Desktop/proyectos/Fitbar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4618325b"]])

export default __exports__